export default from './MortgageBalanceQuestion';



// WEBPACK FOOTER //
// ./src/sharedComponents/Quiz/components/MortgageBalanceQuestion/index.js